import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';

// Do not use handleError here: it assumes an HTTP response and dispatches alerts
// before the page can discard a stale unit request. The page owns these alerts.
const request = async ( endpoint, unitCode, options ) => {

    try {

        const response = await fetchService.fetch( `${getBasePath()}${endpoint}`, {
            ...options,
            headers: { ...( unitCode ? { Unit: unitCode } : {} ), 'Content-Type': 'application/json' }
        } );
        if ( response.ok === false ) throw response;
        return await response.json();

    } catch ( error ) {

        if ( error.name === 'AbortError' ) throw error;
        // Preserve status even when the HTTP error body is empty/non-JSON.
        const failure = new Error( 'Unable to contact the family availability service.' );
        failure.status = error.status;
        if ( typeof error.json === 'function' ) {

            try {

                await error.json();

            } catch ( ignored ) {

                // The HTTP status is sufficient; never expose server internals.

            }

        }
        throw failure;

    }

};

export const getAvailabilityUnits = signal => request( '/units', null, { method: 'GET', signal } );

export const getFamilyAvailability = ( unitCode, signal ) => request( '/batch-admin/reset-sna', unitCode, { method: 'GET', signal } );

export const updateFamilyAvailability = ( unitCode, snapshot, signal ) => request( '/batch-admin/reset-sna', unitCode, {
    method: 'POST',
    signal,
    body: JSON.stringify( { updates: snapshot.updates, systemNotAvailable: snapshot.systemNotAvailable } )
} );